import React from "react";
import { IdCard, Scroll, Stamp, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const solutions = [{
  title: "Custom AV Design",
  description: "Tailored audiovisual systems to fit your needs regardless of the environment.",
  icon: IdCard,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/digital_offset_printing_zoom.png",
  href: "/SolutionsPage"
}, {
  title: "Turnkey Integration",
  description: "Comprehensive end-to-end solutions covering low voltage, data, and electrical services from concept to completion.",
  icon: Scroll,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/large_format_roll_zoom.png",
  href: "/SolutionsPage"
}, {
  title: "Professional Installation",
  description: "Expert deployment of technicians to install, program, commission and service your technoloy solutions.",
  icon: Stamp,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/custom_branding_seal_zoom.png",
  href: "/SolutionsPage"
}];
export default function OurPrintSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="13219" id="core-technical-services" ref={ref} className="dark bg-background py-24 sm:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className={`mb-16 max-w-2xl transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl font-sans font-bold uppercase tracking-tighter text-foreground sm:text-5xl mb-6">
            Core Technical Services
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">Workplace Technology Solutions (WTS) specializes in delivering fully integrated, custom audiovisual systems tailored to your unique environment.&nbsp;</p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-8 mt-8 mb-16">
          
          
          
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((solution, i) => <Link key={i} to={solution.href} className="block h-full" data-index={i}>
              <Card className={`group relative h-full overflow-hidden border border-border bg-card transition-all duration-500 hover:border-primary hover:shadow-2xl hover:-translate-y-1 hover:bg-gradient-to-br hover:from-primary/5 hover:to-transparent ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <div className="absolute inset-0 z-0 bg-cover bg-center opacity-0 transition-all duration-700 ease-out group-hover:opacity-5 group-hover:scale-110" style={{
              backgroundImage: `url(${solution.image})`
            }} />

                <CardContent className="relative z-10 flex h-full flex-col justify-between p-8 sm:p-10">
                  <div className="space-y-6">
                    {}
                    <div className="text-primary transition-all duration-300 group-hover:scale-110">
                      <solution.icon strokeWidth={1.25} className="h-12 w-12" />
                    </div>

                    {}
                    <div className="space-y-3">
                      <h3 className="font-sans text-xl font-bold uppercase tracking-tighter text-foreground">
                        {solution.title}
                      </h3>
                      <p className="text-muted-foreground leading-relaxed">
                        {solution.description}
                      </p>
                    </div>
                  </div>

                  {}
                  <div className="mt-8 flex items-center gap-2 text-sm font-mono font-medium text-primary opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-2">
                    <span>TECHNICAL SPECS</span>
                    <ArrowRight className="h-4 w-4" />
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>

        <div className={`mt-16 flex justify-center transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Link to="/ContactPage">
            <Button size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-4 h-12 px-8 text-base uppercase tracking-widest text-primary-foreground rounded-sm !bg-[hsl(0,95%,41%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">
              Start Your Project
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}